export default function Game_Score() {
  return (
    <div>
      <h1>Game_Score Component</h1>
    </div>
  );
}
